import { useEffect, useState } from "react";

const HOVER_MEDIA_QUERY = "(hover: hover)";

const useSupportsHover = () => {
    const [supportsHover, setSupportsHover] = useState(
        () => window.matchMedia(HOVER_MEDIA_QUERY).matches,
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia(HOVER_MEDIA_QUERY);
        const handleChange = () => setSupportsHover(mediaQuery.matches);

        mediaQuery.addEventListener("change", handleChange);
        return () => mediaQuery.removeEventListener("change", handleChange);
    }, []);

    return supportsHover;
};

export default useSupportsHover;
